import { match } from 'react-router-dom';

const getLocalRouteForMatch = ({ url }: match<{}>) => (localRoute = '') =>
  `${url}/${localRoute}`;

export default getLocalRouteForMatch;
